import { LoaderCircle } from "lucide-react";

import { useDelay } from "@/components/hooks/useDelay";
import { cn } from "@/lib/utils";

export function Spinner({
  delay = 0,
  className,
}: {
  delay?: number;
  className?: string;
}) {
  const show = useDelay(delay);

  return (
    <div
      className={cn(
        "flex items-center justify-center",
        "transition-opacity",
        show || delay === 0 ? "opacity-100" : "opacity-0",
        className,
      )}
    >
      <LoaderCircle className="animate-spin" />
    </div>
  );
}
